import React from 'react'
import PropTypes from 'prop-types'
import { Route, Redirect } from 'react-router-dom'
import _ from 'lodash'

const AuthmiddlewarePremier = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
  isAuth,
  isPremierRoutes,
  premierUserLoading,
  isPremierUser,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) => {
      if (isPremierRoutes && !isPremierUser) {
        return (
          <Redirect
            to={{ pathname: '/events', state: { from: props.location } }}
          />
        )
      }

      return (
        <Layout>
          <Component {...props} />
        </Layout>
      )
    }}
  />
)

AuthmiddlewarePremier.propTypes = {
  isAuthProtected: PropTypes.bool,
  component: PropTypes.any,
  location: PropTypes.object,
  layout: PropTypes.any,
}

export default AuthmiddlewarePremier